<template>
  <div class="faq-bloc">
    <div class="faq-bloc-header">
      <h2>{{$resx('FaqChildrenAmenitiesInformationsText')}}</h2>
    </div>
    <div class="faq-bloc-body">
      <table class="mytable">
        <thead>
          <tr>
            <th>{{$resx('FaqChildrenTableHeader1Text')}}</th>
            <th>{{$resx('FaqChildrenTableHeader2Text')}}</th>
            <th>{{$resx('FaqChildrenTableHeader3Text')}}</th>
            <th>{{$resx('FaqChildrenTableHeader4Text')}}</th>
            <th>{{$resx('FaqChildrenTableHeader5Text')}}</th>
            <th>{{$resx('FaqChildrenTableHeader6Text')}}</th>
          </tr>
        </thead>
        <tbody v-show="!isSaving">
          <tr v-for="(item, index) in modelCopy" :key="item.id" :class="{inactive : !item.isValid}">
            <td>{{item.name}}<input type="hidden" :value="item.id" /></td>
            <td>
              <span v-if="!editMode">{{item.minAge}}</span>
              <input v-if="editMode" type="number" v-model.number="item.minAge" min="0" max="17" :ref="getFieldName('minAge',index)"  :name="getFieldName('minAge',index)"  v-validate="'numeric|max:17'" :class="{'field-validation-error': errors.has(getFieldName('minAge',index)) }"/>
            </td>
            <td>
              <span v-if="!editMode">{{item.maxAge}}</span>
              <input v-if="editMode" type="number" v-model.number="item.maxAge" min="1" max="18" :name="getFieldName('maxAge',index)"  v-validate="'numeric|max:18|isIntBigger:'+getFieldName('minAge',index)" :class="{'field-validation-error': errors.has(getFieldName('maxAge',index)) }"/>
            </td>
            <td>
              <span v-if="!editMode && item.isFree===null">?</span>
              <i v-if="!editMode && item.isFree!==null" class='material-icons'>{{getCheckStateClass(item.isFree)}}</i>
              <select v-if="editMode" v-model="item.isFree">
                <option v-bind:value="null">?</option>
                <option v-bind:value="true">{{$resx('FreeText')}}</option>
                <option v-bind:value="false">{{$resx('NotFreeText')}}</option>
              </select>
            </td>
            <td>
              <span v-if="!editMode">{{getFormatedDate(item.openingDate)}}</span>
              <input v-if="editMode" type="date" class="form-control" v-model="item.inputOpeningDate" :ref="getFieldName('minDate',index)"  :name="getFieldName('minDate',index)" :min="dateMin" :max="dateMax"  v-validate="'date_format:yyyy-mm-dd'" :class="{'field-validation-error': errors.has(getFieldName('minDate',index))}"/>
            </td>
            <td>
              <span v-if="!editMode">{{getFormatedDate(item.closingDate)}}</span>
              <input v-if="editMode" type="date" class="form-control" v-model="item.inputClosingDate" :ref="getFieldName('maxDate',index)"  :name="getFieldName('maxDate',index)" :min="dateMin" :max="dateMax"   v-validate="'date_format:yyyy-mm-dd|isDateBigger:'+getFieldName('minDate',index)" :class="{'field-validation-error': errors.has(getFieldName('maxDate',index))}" />
            </td>
          </tr>
        </tbody>
        <tfoot v-show="isSaving">
          <tr>
            <td colspan="6" class="text-center">
              <i class="loading material-icons">cached</i>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="faq-bloc-footer">
      <button v-show="!editMode" class="btn btn-secondary" @click="editMode=true">{{$resx('EditText')}}</button>
      <button v-show="editMode" class="btn btn-secondary" @click="editMode=false">{{$resx('CancelText')}}</button>
      <button v-show="editMode" style="margin-left:.5em" class="btn btn-primary" @click="save" :disabled="isSaving">{{$resx('SaveText')}}</button>
    </div>
  </div>
</template>
<script>
import FaqChildren from '../../models/faq/faqChildren'
import faqServices from '../../services/faqServices'
import helperServices from '../../services/helperServices'
var moment = require('moment')

export default {
  props: {
    items: null
  },
  data () {
    return {
      isSaving: false,
      editMode: false,
      modelCopy: null,
      dateMin: null,
      dateMax: null
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  watch: {
    editMode: function () {
      this.modelCopy = this.copyFullObject(this.items)
    }
  },
  methods:
  {
    // Copie de l'objet référence dans une autre variable
    copyFullObject: function (source) {
      var newObjs = []

      if (source !== null) {
        source.forEach(function (element) {
          newObjs.push(new FaqChildren(element))
        })
      }
      return newObjs
    },

    // retourne l'icone pour indiquer le statut d'un item
    getCheckStateClass: function (value) {
      if (value === null) {
        return 'fa-question'
      } else {
        return value ? 'check' : 'close'
      }
    },

    // sauvegarde des éléments
    save () {
      const self = this
      self.isSaving = true

      // recuperer dates saisies
      this.modelCopy.forEach(function (elt) {
        elt.openingDate = helperServices.getDateFromInput(elt.inputOpeningDate)
        elt.closingDate = helperServices.getDateFromInput(elt.inputClosingDate)
      })

      faqServices.saveChildrenAmenities(this.currentCampingId, this.modelCopy)
        .then(response => {
          // signaler l'update au parent
          self.$emit('update-items', this.copyFullObject(this.modelCopy))
          self.isSaving = false
          self.editMode = false
          const message = self.$resx('FaqSavedText')
          self.$store.commit('app/showSnack', { type: 'success', message: message })
        })
        .catch(error => {
          self.isSaving = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },

    // Retourne un nom de champ unique
    getFieldName (prefix, index) {
      return prefix + '_' + index
    },

    // Retourne une date formatée pour le user
    getFormatedDate (jsonDate) {
      return helperServices.getFormatedDate(jsonDate)
    },

    // Retourne une heure formatée pour le user
    getFormatedTime (jsonTime) {
      return helperServices.getFormatedTime(jsonTime)
    }
  },
  created: function () {
    // console.log('faqchildren created')
    this.modelCopy = this.copyFullObject(this.items)
    this.dateMin = moment().format('YYYY-01-01')
    this.dateMax = moment().add(1, 'year').format('YYYY-12-31')
  }
}
</script>
